import { assoc, forEach, path } from 'ramda';

const hastApproveProjects = user => user.approveProjects && !path(['metroData'], user);

const accounts = {
    'DoEducationSupport': {
        permission: 'education',
        getPermissions: user => ({
            office: true,
            approveEducation: user.approveEducation
        })
    },
    'DoWebSupport': {
        permission: 'web',
        getPermissions: user => ({
            approvals: hastApproveProjects(user) || user.approvePeople,
            approveProjects: hastApproveProjects(user),
            approvePeople: user.approvePeople,
            request: user.staffRequest && !path(['metroData'], user),
            project: user.responsible || user.coexecutive,
            projectMass: user.responsibleMAP || user.coexecutiveMAP,
            trainerEvents: user.trainer || user.assessor,
            userFilter: !path(['metroData'], user),
        }),
    },
    'DoEmployeeSupport': {
        permission: 'employee',
        getPermissions: user => ({
            metro: !!path(['metroData'], user),
            metroRequest:  !!path(['metroData', 'isDepartmentHead'], user),
            metroApproval: !!path(['metroData', 'isApprover'], user),
        }),
    }
};

export const countersMapper = (counters = {}, user = {}) => ({
    person: user.approvePeople ? counters.person : {},
    project: hastApproveProjects(user) ? counters.project : {},
    notdone: counters.notdone,
});

export default (user = {}) => {
    let permissions = {
        web: false,
        education: false,
        employee: false,
    };

    forEach(account => {
        const accountConfig = accounts[account.name];

        if (accountConfig) {
            permissions = assoc(
                accountConfig.permission,
                accountConfig.getPermissions(user, account),
                permissions
            );
        }
    }, user.accounts || []);

    return {
        permissions,
        ...user
    };
};
